import React from 'react';
import { Redirect } from 'react-router-dom';
import { Image, Row } from 'react-bootstrap';

import "./AccountSuspended.css";

import { Auth } from '../../support';
import FloatButtonSupport from '../../layouts/components/FloatButtonSupport';

const AccountSuspended = () => {

  if (!Auth.isAuthenticated()) {
    return <Redirect to="/auth/login" />;
  }

  return (
    <Row className="suspended-container">
      <div className="col-md-6 offset-md-3">
        <div className="logo pb-3">
          <Image src="/img/logo-pactopia.png"
            className="suspended-logo-img"
            fluid={ true }
          />
        </div>

        <div className="suspended-title text-upper title pb-3">
          <strong>Tu cuenta ha sido <br /> temporalmente suspendida.</strong>
        </div>

        <div className="pactopia-tipografia pb-3">
          <strong>
            Tu cuenta actualmente presenta un cargo vencido. <br /> Es importante generar el pago para que puedas acceder a tu cuenta.
          </strong>
        </div>

        <div className="pactopia-tipografia">Para generar tu pago o cualquier aclaración, por favor comunicate via correo a facturacion@pactopia.mx.
        </div>

        <div className="text-muted">
          <small>Waretek México SAPI de CV Copyright 2023</small>
        </div>
      </div>

      <FloatButtonSupport to="/suspended/send-mail" email="facturacion@pactopia.mx" />
    </Row>
  );
}

export default AccountSuspended;